export class AuthConstants {
  public static readonly AUTH = 'userData';
  public static readonly TOKEN = 'token';
  public static readonly ID = 'id';
  public static readonly PERMISSION = 'permission';
  public static readonly MANHOMQUYEN = 'maNhomQuyen';
  public static readonly HRM_TOKEN = 'hrm_token';
}
